import React from 'react';
import ReactDOM from "react-dom";
import * as constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';
import pageStore from 'stores/AovProgressBar/PageStore';




export function updateLoadedCart(loadedCart) {
  if (pageStore.loadedCart === loadedCart) return;
  pageStore.setLoadedCart(loadedCart);
  updatePageAppElementStyles();
}


export function handleCartUpdate(response) {
  if (pageStore.isShopify) {
    handleShopifyCartUpdate(response);
  }

  if (pageStore.isBigCommerce) {
    handleBigCommerceCartUpdate(response);
  }

  if (pageStore.isEasyStore) {
    handleEasyStoreCartUpdate(response);
  }

  if (pageStore.isShopline) {
    handleShoplineCartUpdate(response);
  }

  if (pageStore.isShopware) {
    handleShopwareCartUpdate(response);
  }

  if (pageStore.isWix) {
    handleWixCartUpdate(response);
  }

  if (pageStore.isWooCommerce) {
    handleWooCommerceCartUpdate(response);
  }

  if (pageStore.onCartUpdatedCallback) {
    try {
      pageStore.onCartUpdatedCallback();
    } catch (error) {
      console.error(error);
    }
  }
}


function handleShopifyCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  let totalPrice = null;
  // if need to use before auto discounted amount
  // total_price uses subtotal which is currently more stable
  // if (response.hasOwnProperty('items_subtotal_price')) totalPrice = response.items_subtotal_price;
  // if (totalPrice === null && response.hasOwnProperty('original_total_price')) totalPrice = response.original_total_price;
  if (totalPrice === null && response.hasOwnProperty('total_price')) totalPrice = response.total_price;
  if (totalPrice === null) return;

  let cartAmount = utils.formatCartAmountForShopify(totalPrice);
  if (!utils.isNumeric(cartAmount)) return;
  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}


function handleBigCommerceCartUpdate(response) {
  if (!response) {
    pageStore.setCartAmount(0);
    updateLoadedCart(true);
    return;
  }

  let cartAmount = response.cartAmount;
  if (!utils.isNumeric(cartAmount)) {
    pageStore.setCartAmount(0);
    updateLoadedCart(true);
    return;
  }

  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}


function handleEasyStoreCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  let cartAmount = utils.extractEasyStoreCartAmount(response);
  if (cartAmount && utils.isNumeric(cartAmount)) {
    pageStore.setCartAmount(cartAmount);
  } else {
    pageStore.setCartAmount(0);
  }

  updateLoadedCart(true);
}


function handleShoplineCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  if (!response.hasOwnProperty('total_price')) return;
  let cartAmount = response.total_price;
  if (!utils.isNumeric(cartAmount)) return;
  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}

function handleShopwareCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  let cartAmount = response.price.totalPrice;
  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}

function handleWixCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  let cartAmount = response.convertedTotals.subTotal;
  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}


function handleWooCommerceCartUpdate(response) {
  if (!(response instanceof Object)) {
    try {
      response = JSON.parse(response);
    } catch(e) {
      return;
    }
  }

  let cartAmount = utils.formatAmount(response.subtotal);
  if (!utils.isNumeric(cartAmount)) return;
  pageStore.setCartAmount(cartAmount);
  updateLoadedCart(true);
}



export function loadAovProgressBarCustomStyles(el, aov) {
  updateAppElementStyles(aov);

  let elementId = `ov_app_aov_progress_bar_styles_${aov.id}`;
  let existingTag = document.getElementById(elementId);
  if (existingTag) existingTag.remove();

  let styles = require('containers/AovProgressBar/styles').default;
  let innerHTML = styles;
  if (utils.isProduction()) innerHTML = aov.cssStyles || "";

  let tag = document.createElement('style');
  tag.id = elementId;
  tag.innerHTML = innerHTML;
  el.after(tag);

  // custom css styles
  if (aov.customCssStyles) {
    elementId = `ov_app_aov_progress_bar_custom_styles_${aov.id}`;
    existingTag = document.getElementById(elementId);
    if (existingTag) existingTag.remove();

    tag = document.createElement('style');
    tag.id = elementId;
    tag.innerHTML = aov.customCssStyles;
    el.after(tag);
  }

  // add css classes
  if (aov.cssClasses && aov.cssClasses.length) {
    aov.cssClasses.forEach((cssClass) => {
      if (el.classList.contains(cssClass)) return;
      el.classList.add(cssClass);
    })
  }
}


export function reload() {
  if (!utils.isProduction()) return;
  pageStore.setAovList([]);

  // loadAovProgressBar
  const nodeList = document.querySelectorAll(".ov-app-aov-progress-bar");

  nodeList.forEach((el) => {
    const appId = el.getAttribute('data-app-id');
    if (!appId) return;

    const AovProgressBarStore = require('stores/AovProgressBar/AovProgressBarStore').default;
    const aov = new AovProgressBarStore();
    aov.setId(appId);
    aov.setEl(el);
    pageStore.addAov(aov);

    const AovProgressBar = require('containers/AovProgressBar').default;
    const component = <AovProgressBar aov={aov} />;
    const successCallback = async (response) => {
      await aov.deserialize(response);
      loadAovProgressBarCustomStyles(el, aov);
      ReactDOM.render(component, el);
    };

    const errorCallback = (errors) => {
      utils.printErrors(errors);
    };

    const params = aov.params;
    api.getAovProgressBarPayloads(successCallback, errorCallback, aov.id, params);
  })

  utils.loadInitialCartData();
}



export function setupPlacement(el, aov) {
  if (!aov.isSelectorPlacement) return el;

  let referenceNode = document.querySelector(aov.placementCssSelector);
  if (!referenceNode) return null;

  el = document.createElement("div");
  el.className = "ov-app ov-app-aov-progress-bar";
  el.setAttribute("data-app", "aov-progress-bar");
  el.setAttribute("data-app-id", aov.id);

  if (aov.insertPositionBefore) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
  }

  if (aov.insertPositionAfter) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
  }

  aov.setEl(el);
  return el;
}

export function updateAppElementStyles(aov) {
  const el = aov.el;
  if (!el) return;

  if (aov.display && pageStore.display) {
    el.style.display = "block";
  } else {
    el.style.display = "none";
  }
}

export function updatePageAppElementStyles() {
  pageStore.aovList.forEach((aov) => {
    if (!aov.el) return;
    updateAppElementStyles(aov);
  })
}


